var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-home"},[_c('side-nav',{attrs:{"nav-list":_vm.navList}},[_c('div',{staticClass:"logo-box color-white f-df f-ai pd-left10"},[_c('figure',{staticClass:"mg-right10 icon-logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"width":"100%","height":"100%"}})]),_c('figcaption',[_vm._v("内容管理与分析系统")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }